"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaskedParagraphPropertiesBundleFull = exports.MaskedParagraphPropertiesBundle = exports.MaskedCharacterPropertiesBundle = exports.ParagraphListInfo = exports.PropertiesBundle = void 0;
var tslib_1 = require("tslib");
var numbering_list_1 = require("../model/numbering-lists/numbering-list");
var PropertiesBundle = (function () {
    function PropertiesBundle(properties, style) {
        this.props = properties;
        this.style = style;
    }
    return PropertiesBundle;
}());
exports.PropertiesBundle = PropertiesBundle;
var ParagraphListInfo = (function () {
    function ParagraphListInfo(numbericListIndex, listLevelIndex) {
        this.numberingListIndex = numbericListIndex;
        this.listLevelIndex = listLevelIndex;
    }
    Object.defineProperty(ParagraphListInfo, "default", {
        get: function () {
            return new ParagraphListInfo(numbering_list_1.NumberingList.NumberingListNotSettedIndex, -1);
        },
        enumerable: false,
        configurable: true
    });
    ParagraphListInfo.prototype.clone = function () {
        return new ParagraphListInfo(this.numberingListIndex, this.listLevelIndex);
    };
    return ParagraphListInfo;
}());
exports.ParagraphListInfo = ParagraphListInfo;
var MaskedCharacterPropertiesBundle = (function (_super) {
    tslib_1.__extends(MaskedCharacterPropertiesBundle, _super);
    function MaskedCharacterPropertiesBundle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return MaskedCharacterPropertiesBundle;
}(PropertiesBundle));
exports.MaskedCharacterPropertiesBundle = MaskedCharacterPropertiesBundle;
var MaskedParagraphPropertiesBundle = (function (_super) {
    tslib_1.__extends(MaskedParagraphPropertiesBundle, _super);
    function MaskedParagraphPropertiesBundle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return MaskedParagraphPropertiesBundle;
}(PropertiesBundle));
exports.MaskedParagraphPropertiesBundle = MaskedParagraphPropertiesBundle;
var MaskedParagraphPropertiesBundleFull = (function (_super) {
    tslib_1.__extends(MaskedParagraphPropertiesBundleFull, _super);
    function MaskedParagraphPropertiesBundleFull(properties, style, listInfo, tabs) {
        var _this = _super.call(this, properties, style) || this;
        _this.listInfo = listInfo;
        _this.tabs = tabs;
        return _this;
    }
    Object.defineProperty(MaskedParagraphPropertiesBundleFull, "notSetted", {
        get: function () {
            return new MaskedParagraphPropertiesBundleFull(undefined, undefined, undefined, undefined);
        },
        enumerable: false,
        configurable: true
    });
    return MaskedParagraphPropertiesBundleFull;
}(PropertiesBundle));
exports.MaskedParagraphPropertiesBundleFull = MaskedParagraphPropertiesBundleFull;
